export const CONSTANT = {
  /** DISPATCHER PREFIX */
  DISPATCHER_SECURITY_PREFIX: "/security",
  DISPATCHER_USER_PREFIX: "/users",
  DISPATCHER_MAINTENANCE_PREFIX: "/maintenance",

  /** LANGUAGE */
  DEFAULT_LANGUAGE_ES: "ES",
  DEFAULT_LANGUAGE_EN: "EN",

  /** TYPE MESSAGE */
  SUCCESS_MSG: 1,
  ERROR_MSG: 2,
  WARNING_MSG: 3,

  /** LABELS */
  LABEL_CRM: "CRM",
  LABEL_DASHBOARD: "Dashboard",
  /** Users **/
  LABEL_USERS: "Usuarios",
  LABEL_NEW_USER: "Registrar Usuario",
  LABEL_EDIT_USER: "Editar Usuario",
  LABEL_SAVE_USER: "Guardar Usuario",
  LABEL_USERS_ACTIVE: "Usuarios activos",
  /** Clients **/
  LABEL_CLIENTS: "Clientes",
  LABEL_NEW_CLIENT: "Registrar Cliente",
  LABEL_EDIT_CLIENT: "Editar Cliente",
  LABEL_SAVE_CLIENT: "Guardar Cliente",
  /** Companies **/
  LABEL_COMPANIES: "Empresas",
  LABEL_SELECT_COMPANY: "Seleccione una empresa",
  LABEL_NOT_COMPANY: "Sin empresa asignada",
  LABEL_NOT_COUNTRY: "Sin país asignado",
  LABEL_COMPANY: "Empresa",
  LABEL_NEW_COMPANY: "Registrar Empresa",
  LABEL_EDIT_COMPANY: "Editar Empresa",
  LABEL_SAVE_COMPANY: "Guardar Empresa",
    /** Customer Statuses **/
  LABEL_CUSTOMER_STATUSES: "Estados",
  LABEL_SELECT_CUSTOMER_STATUS: "Seleccione un estado",
  LABEL_NOT_CUSTOMER_STATUS: "Sin estado asignado",
  LABEL_CUSTOMER_STATUS: "Estado",
  LABEL_NEW_CUSTOMER_STATUS: "Registrar Estado",
  LABEL_EDIT_CUSTOMER_STATUS: "Editar Estado",
  LABEL_SAVE_CUSTOMER_STATUS: "Guardar Estado",


  /** Leads Tags **/
  LABEL_LEADS_TAGS: "Etiquetas",
  LABEL_SELECT_LEAD_TAG: "Seleccione una etiqueta",
  LABEL_NOT_LEAD_TAG: "Sin etiqueta asignada",
  LABEL_LEAD_TAG: "Etiqueta",
  LABEL_NEW_LEAD_TAG: "Registrar Etiqueta",
  LABEL_EDIT_LEAD_TAG: "Editar Etiqueta",
  LABEL_SAVE_LEAD_TAG: "Guardar Etiqueta",

  /** Country **/
  LABEL_COUNTRY: "País operador",
  /** Leads **/
  LABEL_LEADS: "Leads",
  LABEL_NEW_LEAD: "Registrar Lead",
  LABEL_EDIT_LEAD: "Editar Lead",
  LABEL_SAVE_LEAD: "Guardar Lead",
  LABEL_LAST_CONTACT: "Ultimo contacto",
  LABEL_CLIENTS_LEADS: "Leads",
  /** Whatsapp **/
  LABEL_WHATSAPP: "Whatsapp",
  LABEL_WHATSAPP_OUTCOMING: "Whatsapp saliente",
  LABEL_WHATSAPP_INCOMING: "Whatsapp entrante",
  LABEL_OUTCOMING: "saliente",
  LABEL_INCOMING: "entrante",
  /** UserData **/
  LABEL_NAME: "Nombre",
  LABEL_LAST_NAME: "Apellidos",
  LABEL_CELL_PHONE: "Celular",
  LABEL_CELL_PASSWORD: "Contraseña",
  LABEL_EMAIL: "Correo Electrónico",
  LABEL_POSITION: "Cargo",
  LABEL_CANCEL: "Cancelar",
  LABEL_SAVE_EDIT: "Guardar Cambios",
  LABEL_CLOSE: "Cerrar",
  /****/
  LABEL_ACCION: "Acciones",
  LABEL_ID: "Id",
  LABEL_STATUS: "Estado",

  /** COMMENTS */
  COMMENT_NAME_REQUIRED: "Nombre requerido",
  COMMENT_JOB_TITLE_REQUIRED: "Cargo requerido",
  COMMENT_COMPANY_REQUIRED: "Empresa requerida",
  COMMENT_CELL_PHONE_INVALID: "Celular inválido",
  COMMENT_CELL_PHONE_REQUIRED: "Celular requerido",
  COMMENT_EMAIL_INVALID: "Correo Electrónico inválido",
  COMMENT_EMAIL_REQUIRED: "Correo Electrónico requerido",
  COMMENT_REQUIRED: "Requerido",

  /** Templates **/
  LABEL_TEMPLATE_TWILIO: "Plantillas de Twilio",
  LABEL_TEMPLATE_QUICK_RESPONSE: "Respuestas rápidas",
  LABEL_TEMPLATE_AUTO_REPLY: "Respuestas automáticas",
  LABEL_MASSIVE: "Masivos",
  LABEL_EDIT_FLOW: "Editar flujo",
  LABEL_DELETE_FLOW: "Eliminar flujo",
  LABEL_EDIT_STAGES_FLOW: "Ver/Editar respuestas",

  LABEL_TEMPLATE: "Plantilla",
  LABEL_NEW_TEMPLATE: "Registrar plantilla",
  LABEL_DELETE_TEMPLATE: "Eliminar plantilla",
  LABEL_EDIT_TEMPLATE: "Editar plantilla",
  LABEL_SAVE_TEMPLATE: "Guardar plantilla",
  LABEL_CONFIRMATION_DELETE_TEMPLATE:
    "¿Estás seguro de que deseas eliminar la plantilla?",
  LABEL_ACTIVE_TEMPLATE: "Activar",
  COMMENT_TEMPLATE_REQUIRED: "Plantilla requerida",

  /** SOCIALNETWORKTYPE */
  SOCIALTYPE_FACEBOOK: "FACEBOOK",
  SOCIALTYPE_INSTAGRAM: "INSTAGRAM",
  SOCIALTYPE_TWITTER: "TWITTER",
  SOCIALTYPE_LINKEDIN: "LINKEDIN",
  SOCIALTYPE_YOUTUBE: "YOUTUBE",

  /** HEADER TYPE */
  HEADER_TYPE: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  HEADER_TYPE2: {
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
  },
  HEADER_TYPE_FILE: {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
  },
  AUTH_GRANTTYPE: "password",
  LABEL_SETTING: "Configuración",
  LABEL_NEW_MESSAGE: "Nueva notificación",
  LABEL_WEBSOCKET_ACTIVE: "Conectado al WebSocket",
  LABEL_WEBSOCKET_DESACTIVE: "Desconectado del WebSocket",

  LABEL_MESSAGE_MASSIVE: "Mensaje masivo",

  LABEL_CREATE_BY: "Creado por",
  LABEL_CREATE_DATE: "Fecha de creación",
  LABEL_APPROVED: "Aprobado",
  LABEL_APPROVE: "Aprobar",
  LABEL_NOT_APPROVE: "No aprobar",
  LABEL_SEE_DETAIL: "Ver detalle",
  LABEL_BACK: "Atrás",
  LABEL_SENT: "Enviado",
  LABEL_SENT_DATE: "Fecha enviado",
  LABEL_MESSAGE_MASSIVE_TITLE: "Mensaje masivo",
  LABEL_MESSAGE_MASSIVE_TITLE_CONFIRMATION:
    "¿Está seguro de que desea enviar el mensaje masivo?",
  LABEL_MESSAGE_MASSIVE_TITLE_CONFIRMATION_DELETE:
    "¿Está seguro de que desea rechazar el envío del mensaje masivo?",

  /** Reports **/
  LABEL_REPORTS: "Reportes",
  LABEL_WEEKLY: "Semanal",
  LABEL_MONTHLY: "Mensual",
  LABEL_WEEKLY_REPORT: "Reporte Semanal",
  LABEL_WEEKLY_REPORT_SUBTITLE: "Comparativo semanal de métricas por usuario",
  LABEL_MONTHLY_REPORT: "Reporte Mensual",
  LABEL_MONTHLY_REPORT_SUBTITLE: "Comparativo mensual de métricas por usuario",
};
